
/**
 * 加载组件
 * @param view
 * @returns {function(): (Promise<*>|*)}
 */
export const loadView = (view) => {
  return () => import(`@/pages${view}`)
  // return () => import(view)
}
export const filterAsyncRouter = (routers) => {
  return routers.filter(router => {
    if (router.component) {
      // if (router.nodeData.component === 'Layout') { // Layout组件特殊处理
      //     console.log(router.nodeData.component,'-------------')
      //   // router.component = Layout
      //   router.component = () => import('@/layout')
      //   // router.component = loadAll('layout')
      // } else {
      // console.log(router.nodeData.component)
      const component = router.path
      router.component = loadView(component)
      // }
    }

    router.name = router.name
    router.meta = { title: router.meta.title, icon: router.meta.icon }
    // const meta = router.meta
    // if (meta !== undefined && meta !== null && meta !== '') {
    //   const json = JSON.parse(meta)
    //   if (json.affix) {
    //     router.meta.affix = json.affix
    //   }
    // }

    router.path = router.path
    // router.redirect = router.redirect
    //
    if (router.children && router.children.length > 0) {
      router.children = filterAsyncRouter(router.children)
    } else {
      delete router.children
    }
    return true
  })
}



// WEBPACK FOOTER //
// ./src/utils/appUtil.js